import { Option } from '../../../types/common/table';

export const INITIAL_OPTION: Required<Option<any>> = {
  filterOption: {},
  pagination: {
    pageSize: 100,
    pageNum: 0,
  },
  sortOption: {},
};
